/**
 * Módulo de Dados — definição do módulo (frontend)
 *
 * Fase 1 de docs/PLANO_MODULO_DADOS.md. Nem todo jogo usa dado: o book_ia é um
 * jogo sem dado nenhum, e até aqui toda mesa mostrava "Rolar Dados".
 *
 * O módulo não cria tela nova. Ele porteia os pontos de entrada que já existem
 * (ações rápidas, ficha, modal compartilhado): com o módulo desligado, todos
 * somem e a API recusa com 403.
 */
import type { GameModule } from '../types'

/** Id do módulo. Vale para o gate no frontend e para a rota da API. */
export const DICE_MODULE_ID = 'dice'

export const DiceModule: GameModule = {
  manifest: {
    id: DICE_MODULE_ID,
    name: 'Dados',
    version: '1.0.0',
    description:
      'Rolagem de dados na mesa e teste de atributo pela ficha. Desligue em mesas que jogam sem dado.',
    icon: 'Dices',
    requiredRole: 'professor',
  },
  ConfigPanel: () => null, // Sem configuração: liga/desliga pelo gerenciador
}
